import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const LatestProjectReviewCard = styled.div`
  background: #f7f8f9;
  border: 1px solid #d2d5da;
  border-radius: 3px;
  padding: 24px;
  display: grid;
  grid-template-columns: 100px 1fr 154px;
  gap: 16px;
  margin-top: 16px;
  @media (${mediaQuery.mobile}) {
    grid-template-columns: 100px 1fr;
  }
`;

export const LatestProjectReviewImage = styled.img`
  width: 100px;
  object-fit: cover;
  @media (${mediaQuery.mobile}) {
    grid-row: 1 / span 2;
  }
`;

export const LatestProjectReviewDetail = styled.div`
  display: grid;
  gap: 4px;
`;

export const LatestProjectReviewButton = styled.a`
  color: #fff;
  background: #0081c6;
  border-radius: 3px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  height: 40px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 154px;

  &:hover {
    color: #fff;
  }
`;

export const LatestProjectReviewTitle = styled.p`
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 14px;
  color: #697684;
  margin: 0;
`;

export const LatestProjectReviewDescription = styled.p`
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  color: #333f48;
  margin: 0;
`;

export const LatestProjectReviewDateTime = styled.p`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  color: #697684;
  margin: 0;
`;
